import { DART_GAME } from '../constants';

export const checkTargetCollision = (x, y, targetRefs, containerRef) => {
  if (!containerRef) return null;
  
  const containerRect = containerRef.getBoundingClientRect();
  
  for (let index = 0; index < targetRefs.length; index++) {
    const node = targetRefs[index];
    if (!node) continue;
    
    const rect = node.getBoundingClientRect();
    const centerX = rect.left - containerRect.left + rect.width / 2;
    const centerY = rect.top - containerRect.top + rect.height / 2;
    const distance = Math.hypot(x - centerX, y - centerY);
    
    if (distance < DART_GAME.COLLISION_RADIUS) {
      return { index, centerX, centerY };
    }
  }
  
  return null;
};

